
import * as FaIcons from 'react-icons/fa';
import React, { Fragment, useState, useEffect } from 'react'
import { GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { Link } from 'react-router-dom';
import * as AiIcons from 'react-icons/ai';
import * as FcIcons from 'react-icons/fc';
import { useForm } from 'react-hook-form';
import { Modal, Button } from "react-bootstrap";
import AxiosService from "../services/axios.service";
import AuthService from "../services/auth.service";
const API_PATH = "courts";

function List(match) {
  const { path } = match;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [courts, setCourts] = useState(null);
  const [results, setResults] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) { 
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => setCourts(x.data) & setResults(x.data.length));
  }, []);

  const { register, watch, formState: { errors }, handleSubmit } = useForm();

  function search() {
    var keyword = watch("query").toLowerCase();
    console.log("keyword: " + keyword);
    AxiosService.getAll(API_PATH).then(x => {
      console.log(JSON.stringify(x.data));
      var queries = x.data.filter(item => item.name.toLowerCase().includes(keyword))
      setCourts(queries)
      setResults(queries.length)
    }
    );
  }

  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>Courts</h1>
      <form onSubmit={handleSubmit(search)} onReset={useEffect}>
        <div className="form-row">
          <div className="form-group col-5">
            <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
            <div className="invalid-feedback">{errors.query?.message}</div>
          </div>
          <div className="form-group col-5">
            {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
            <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
          </div>
        </div>
      </form>
      <h5>Results: {results}</h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Courts Name</th>
            <th style={{ width: '20%' }}>Courts Abbreviation</th>
          </tr>
        </thead>
        <tbody>
          {courts && courts.map(court =>
            <tr key={court.id}>
              <td>{court.name}</td>
              <td>{court.abbreviation}</td>
            </tr>
          )}
          {!courts &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="spinner-border spinner-border-lg align-center"></div>
              </td>
            </tr>
          }
          {courts && !courts.length &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="p-2">No Courts To Display</div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  );
}

export { List };
